import React from 'react';
import InProgressPolygonOverlay from './layers/InProgressPolygonOverlay';
import { MODE_TO_TYPE, POLYGON_COLORS, isFourPointType } from '../../utils/polygonTypes';

interface CreationOverlayProps {
  mode: string;
  scale: number;
  tempPoints: [number, number][];
  selectedRackForShelf: string | null;
  onTempPointDrag?: (idx: number, x: number, y: number) => void;
}

const CreationOverlay: React.FC<CreationOverlayProps> = ({
  mode,
  scale,
  tempPoints,
  selectedRackForShelf,
  onTempPointDrag,
}) => {
  if (tempPoints.length === 0) return null;

  // Shelf mode requires a rack to be selected first
  if (mode === 'create_shelf' && selectedRackForShelf == null) return null;

  const entityType = MODE_TO_TYPE[mode];
  if (!entityType) return null;

  const color = POLYGON_COLORS[entityType] || 'yellow';

  // Four-point types (rack/shelf/table) care about the start vertex's order —
  // they surface the "продолжайте по часовой стрелке" hint — so mark vertex 0.
  return <InProgressPolygonOverlay points={tempPoints} color={color} scale={scale} closed markStart={isFourPointType(entityType)} onPointDrag={onTempPointDrag} />;
};

export default React.memo(CreationOverlay);
